import React from 'react';
import { Box, Container } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <Navbar />
      <Container component="main" sx={{ flex: 1, my: 2 }}>
        <Outlet />
      </Container>
      <Footer />
    </Box>
  );
};

export default Layout;
